import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Initialize theme on page load
    this.initializeTheme()

    // Listen for system theme changes
    this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    this.mediaQuery.addEventListener('change', (e) => {
      // Only update if user hasn't set a manual preference
      const savedTheme = localStorage.getItem('theme')
      if (savedTheme === 'system' || !savedTheme) {
        this.applyTheme(e.matches ? 'dark' : 'light')
      }
    })
  }

  disconnect() {
    // Clean up event listener
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener('change', this.handleSystemThemeChange)
    }
  }

  initializeTheme() {
    // First check if user has a saved database preference (set by server on html element)
    const htmlElement = document.documentElement
    const hasDarkClassFromServer = htmlElement.classList.contains('dark')

    // If server set dark theme, sync localStorage and return
    if (hasDarkClassFromServer) {
      localStorage.setItem('theme', 'dark')
      return
    }

    // Otherwise, check localStorage preference
    const savedTheme = localStorage.getItem('theme')

    if (savedTheme === 'dark') {
      this.applyTheme('dark')
    } else if (savedTheme === 'light') {
      this.applyTheme('light')
    } else {
      // No preference set or 'system' - use system preference
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      this.applyTheme(systemPrefersDark ? 'dark' : 'light')
      localStorage.setItem('theme', 'system')
    }
  }

  async toggle() {
    const isDark = document.documentElement.classList.contains('dark')
    const newTheme = isDark ? 'light' : 'dark'

    localStorage.setItem('theme', newTheme)
    this.applyTheme(newTheme)

    // Save preference to database
    await this.saveThemePreference(newTheme)
  }

  async saveThemePreference(theme) {
    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

      await fetch('/users/update_theme', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({ theme })
      })
    } catch (error) {
      console.error('Failed to save theme preference:', error)
    }
  }

  applyTheme(theme) {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }
}
